const processRoutes = routes => routes?.filter(r => !r.render);

export default processRoutes;
